// @flow
import React from 'react';
import H4 from '../H4';
import Img from "../Img";

import StyledZammadButton from './StyledZammadButton';

import imgMedia from '../../assets/img/media.svg';

const $ = window.$;

export class ZammadButton extends React.Component {
  componentDidMount() {
    this.$el = $(this.el);
    this.$el.ZammadForm({
      messageTitle: 'Media Inquiry',
      messageSubmit: 'Submit',
      messageThankYou:
        "Thank you for your inquiry (#%s)! We'll contact you as soon as possible.",
      showTitle: true,
      modal: true,
    });
  }

  render() {
    return (
      <StyledZammadButton className="column">
        <a
          ref={el => (this.el = el)}
          className="zammad-button"
          id="technical-support-form"
        >
          <Img src={imgMedia} />
          <div className="contact-text">
            <H4>I have a media inquiry</H4>
            <p>Get in contact with our press team</p>
          </div>
        </a>
      </StyledZammadButton>
    );
  }
}

export default ZammadButton;
